

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { AlertColor } from '@mui/material'


type TosterType = {
  type?: 'success' | 'error' | 'warning' | 'info'
  show?: boolean
  text?: string
}


export interface AppStore {
  isLoading: boolean
  errorMsg: string | null
  toaster: TosterType
  setLoader: (isLoading: boolean) => void
  setErrorMsg: (error: string | null) => void
  showToaster: ({ type, text }: TosterType) => void
  hideToaster: () => void
}


const appStore = (set) => ({
  isLoading: false,
  errorMsg: null,
  toaster: {
    type: 'success' as AlertColor,
    show: false,
    text: '',
  },
  setLoader: (isLoading) => {
    set(() => ({
      isLoading,
    }))
  },
  setErrorMsg: (errorMsg) => {
    set(() => ({
      errorMsg,
    }))
  },
  showToaster: ({ type, text }) => {
    set(() => ({
      toaster: { type, text, show: true },
    }))
  },
  hideToaster: () => {
    set(() => ({
      toaster: { show: false },
    }))
  },
})


export const useAppStore = create(devtools(appStore))
export default useAppStore